import React from 'react';
import { Box } from '@mui/material';

const DynamicIcon = ({ 
  src, 
  activeSrc, 
  isActive, 
  textColor, 
  size = 25,
  alt = "icon",
  isHovered = false,
  hoverTextColor
}) => {
  const iconSrc = isActive && activeSrc ? activeSrc : src;
  const currentTextColor = isHovered ? hoverTextColor : textColor;
  
  // Create CSS filter to change icon color to match text color
  const getIconFilter = () => {
    if (!isActive && !isHovered) return 'none';
    
    // If text is white, make icon white
    if (currentTextColor === '#FFFFFF') {
      return 'brightness(0) invert(1)';
    }
    // If text is black, make icon black  
    else if (currentTextColor === '#000000') {
      return 'brightness(0) invert(0)';
    }
    // For other colors, try to match the text color
    else {
      return 'none';
    }
  };
  
  return (
    <Box
      sx={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          filter: getIconFilter(),
          transition: 'filter 0.2s ease-in-out',
        }
      }}
    >
      <img
        src={iconSrc}
        alt={alt}
        style={{ width: size, height: size }}
      />
    </Box>
  );
};

export default DynamicIcon;